import { render, staticRenderFns } from "./CompareByJson.vue?vue&type=template&id=f68d06e2"
import script from "./CompareByJson.vue?vue&type=script&lang=js"
export * from "./CompareByJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports